<template>
  <q-card-section class="q-mb-md">
    <div class="text-200 text-bold">
      <slot></slot>
    </div>
    <div class="text-125 text-blue-grey-8">
      <slot name="subheading"></slot>
    </div>
  </q-card-section>
</template>

<script>
export default {
  name: "ComparePowerCardHeader"
}
</script>

<style scoped>

</style>
